import Container from "react-bootstrap/Container";
import { server } from "../config";
import TutorialList from "../components/Course/TutorialList";
import { supabase } from "../utils/supabaseClient"
import Meta from "../components/Meta"

export async function getStaticProps() {
  let tutorials = await supabase
  .from("main_tutorial")
  .select()

  tutorials = tutorials.body

  console.log(tutorials)

  return {
    props: {
      tutorials
    },
  };
}

export default function Tutorials(props) {
    return (
      <>
        <Meta 
          title='Building a Django Web App' 
          description="We will cover everything from the basic structures of HTML documents and stylesheets to the Django functionality, design, and deployment." 
        />
        <Container className="py-5 px-15">
            <TutorialList tutorials={props.tutorials}/>
        </Container>
      </>
    )
}


